export default __webpack_public_path__ + "static/media/athenaeum.80346014.png";